import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Error500Component } from './pages/error500/error500.component';

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then(m => m.HomepageModule)
  },
  {
    path: "offers",
    loadChildren: () =>
      import("./offers/offers.module").then(m => m.OffersModule)
  },
  {
    path: "offer",
    loadChildren: () =>
      import("./offers/offers.module").then(m => m.OffersModule)
  },
  {
    path: "redemption-history",
    loadChildren: () =>
      import("./offer-redemption-history/offer-redemption-history.module").then(m => m.OfferRedemptionHistoryModule)
  },
  { path: "error", component: Error500Component },
  {
    path: "info",
    loadChildren: () =>
      import("./info/info.module").then(m => m.InfoModule)
  },
  { path: "**", pathMatch: "full", redirectTo: "" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
